/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_BarcodeInputs */

const vi_packaging_material_barcode = /** @type {(inputs: Packaging_Material_BarcodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vạch`)
};

/**

* @param {Packaging_Material_BarcodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_barcode = /** @type {((inputs?: Packaging_Material_BarcodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_BarcodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_barcode(inputs)
});